import { CONTEST_DURATION_OPTIONS } from './lessonDurationOptions';
import { LESSON_TYPES } from './lessonTypes';

export const CONTEST_LESSON_INPUT_OPTIONS = {
  [LESSON_TYPES.contest]: {
    duration: CONTEST_DURATION_OPTIONS,
    label: 'Contest',
  },
};
